import classNames from 'classnames'
import React, { FC, ReactNode } from 'react'

import s from './WixMobileFooter.scss'

interface WixMobileFooterProps {
  skin?: 'new-funnel' | 'standard'
  children?: ReactNode
}

export const WixMobileFooter: FC<WixMobileFooterProps> = ({ children, skin = 'standard' }) => {
  return (
    <footer
      className={classNames(s.footer, { [s.newFunnel]: skin === 'new-funnel', [s.standard]: skin === 'standard' })}
    >
      {children}
    </footer>
  )
}
